'use client';

import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import Refresh from '@crehana/compass.icons.outline/Refresh';
import { EmptyState } from '@crehana/compass.ui';
import { Button } from '@crehana/compass.ui/button';

type TErrorPageProps = {
  title: string;
  description: string;
  buttonText: string;
  refreshAction: () => void; // Function to refresh or retry the action on the error page
};

export const ErrorPage: React.FC<TErrorPageProps> = ({
  title,
  description,
  buttonText,
  refreshAction,
}) => {
  return (
    <div className="tw-h-full tw-flex tw-items-center tw-bg-neutral-light-100 tw-rounded-0.8 tw-border tw-border-solid tw-border-neutral-light-400 tw-w-full">
      <div className="tw-w-full">
        {/* EmptyState component for displaying error message */}
        <EmptyState
          icon={
            <div className="tw-size-6 tw-bg-alert-100 tw-rounded-full tw-flex tw-justify-center tw-items-center">
              <div className="tw-size-[5rem] tw-bg-alert-200 tw-rounded-full tw-flex tw-justify-center tw-items-center">
                <AlertTriangle size={24} className="tw-text-alert-500" />
              </div>
            </div>
          }
          title={title}
          description={description}
          primaryAction={
            <Button
              type="button"
              variant="primary"
              size="xs"
              className="tw-btn-icon"
              onClick={() => refreshAction()}
            >
              <Refresh size={16} className="tw-text-neutral-light-100" />
              {buttonText}
            </Button>
          }
        />
      </div>
    </div>
  );
};
